import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  getIdentityActions,
  getIdentityUserData,
  isSocialActivatedForIdentityOrganization,
} from 'store/entities/identity/selectors'
import { getActivityId, getActivityUserActivityId } from 'store/entities/activity/selectors'
import { activityActions } from 'store/entities/identity/actions'
import { getUIUserActivityActionsButtonsDisabled, getUIWindowSizesWidth } from 'store/entities/ui/selectors'
import UserActivityControlPanelActivityActions from './UserActivityControlPanelActivityActions'

const mapStateToProps = createStructuredSelector({
  activityId: getActivityId,
  userActivityId: getActivityUserActivityId,
  actions: getIdentityActions,
  isDisabled: getUIUserActivityActionsButtonsDisabled,
  identity: getIdentityUserData,
  windowWidth: getUIWindowSizesWidth,
  isSocialActivated: isSocialActivatedForIdentityOrganization,
})

const mapDispatchToProps = {
  onCommit: activityActions.commit,
  onDid: activityActions.did,
  onDidnot: activityActions.didnot,
}

const mergeProps = (
  { activityId, userActivityId, identity, ...restState },
  { onCommit, onDid, onDidnot },
  ownProps
) => ({
  ...restState,
  ...ownProps,
  onCommit: () => onCommit({ activityId, userActivityId }),
  onDid: () => onDid({ activityId, userActivityId }),
  onDidnot: () => onDidnot({ activityId, userActivityId }),
  activityId,
  identityId: identity.get('id'),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UserActivityControlPanelActivityActions)
